// Init
const Init = (brand, pageType, pageUniqueId) => {
    window.zmp = window.zmp || {}
    window.zmp.cmd = window.zmp.cmd || []

    if (['complete', 'interactive'].indexOf(document.readyState) >= 0) {
        loadScript(pageUniqueId, brand, pageType)
    } else {
        window.addEventListener('DOMContentLoaded', function () {
            loadScript(pageUniqueId, brand, pageType)
        })
    }
}

// Execute custom command method
const Command = (cmd) => {
    window.zmp.cmd.push(cmd)
}

// Commonly used
const UpdateUser = (user) => {
    if (!user || !user.EmailAddress || user.EmailAddress.length <= 0) {
        ClearUser()
        return
    }

    window.zmp.cmd.push(function () {
            /*eslint-disable */
            bt('updateUser', {email: user.EmailAddress, first_name: user.FirstName, last_name: user.LastName},
                {
                    onSuccess: function () {
                        console.log('Update completed successfully!')
                    },
                },
                {
                    onFailure: function (err) {
                        console.log('Update completed with error: ' + err)
                    },
                })
            /*eslint-enable */
        },
    )
}

const ClearUser = () => {
    window.zmp.cmd.push(function () {
            /*eslint-disable */
            bt('clear', {
                onComplete: function () {
                    console.log('Clear function completed!')
                }, onFailure: function (err) {
                    console.log('Error!: ' + err)
                },
            })
            /*eslint-enable */
        },
    )
}

const TrackSearch = (query) => {
    if (!query || query.length <= 0) {
        return
    }

    window.zmp.cmd.push(
        /*eslint-disable */
        bt('track', 'searched', {query: query, brand: 'biblestudytools'},
            {
                onComplete: function () {
                    console.log('Search Call Completed! -> ' + query)
                },
                onSuccess: function () {
                    console.log('Share Call Success!')
                },
                onFailure: function (err) {
                    console.log('Search Error!: ')
                    console.log(err)
                },
            }),
        /*eslint-enable */
    )
}

const TrackShare = (uniqueId, resourceType, url) => {
    window.zmp.cmd.push(
        /*eslint-disable */
        bt('track', 'shared', {'id': uniqueId, 'resourceType': resourceType, 'url': url},
            {
                onComplete: function () {
                    console.log('Share Call Completed!')
                },
                onSuccess: function () {
                    console.log('Share Call Success!')
                },
                onFailure: function (err) {
                    console.log('Search Error!: ')
                    console.log(err)
                },
            })
        /*eslint-enable */
    )
}

// INTERNAL
// Load script
const loadScript = (brand, pageType, pageUniqueId) => {
    const z = document.createElement('script')
    const zmpID = 'salemwebnetwork'
    const z_src = 'https://live.rezync.com/sync?c=16b6410431b6374e780104abb0443ca8&p=61ddc6aac2811775cc68dc2227e8a213&k=salemwebnetwork-pixel-7570&zmpID=' +
        zmpID + '&custom1=' + pageUniqueId + '&custom2=' + brand + '&custom3=' + pageType
    z.setAttribute('src', z_src)
    z.setAttribute('id', 'zmp-script')

    document.body.appendChild(z)

    let script = document.querySelector('#zmp-script')
    script.addEventListener('load', () => {
        window.zmp.cmd.push = function (command) {
            console.log('Pushed command ' + command)
            if (typeof command === 'function') {
                try {
                    command.call(this)
                } catch (e) {
                    if (window.location.href.indexOf('zmpdebug=1') && window.console) {
                        console.log('Error from ZMP CMD: ' + e)
                    }
                }
            }
        }

        doCallStack()
    })
}

// Execute commands
const doCallStack = () => {
    window.zmp.cmd.map(function (cmd) {
        if (typeof cmd.called === 'undefined') {
            try {
                cmd.call()
                cmd.called = true
            } catch (e) {
                if (window.location.href.indexOf('zmpdebug=1') && window.console) {
                    console.log('Error from ZMP Call Stack: ' + e)
                }
            }
        }
    })
    window.zmp.cmd = []
}

export default {
    Init,
    Command,
    UpdateUser,
    ClearUser,
    TrackSearch,
    TrackShare,
}